<template>
  <v-container>
    <v-row class="text-center" id="top">
      <v-col cols="12">
        <h2 class="text-lg-h5 mb-2">함께 자주 사용되는 용어를 알아보세요</h2>
        <p>검색 키워드와 함께 자주 사용되는 본초 또는 병증을 네트워크로 보여줍니다.</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <NetworkTagInput
          :dataItems="dataItems"
          :allReady="allReady"
          :inputMsg="inputMsg"
          :inputOpt="inputOpt"
          @tagUpdated="tagUpdated"
        />
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col cols="12">
        <div class="text-center" v-if="allReady">
          <v-btn
            class="ma-2"
            color="primary"
            rounded
            text-color="white"
            large
            block
            @click="showResult()"
          >
            Show Result
            <v-chip
              right
              size="24"
              class="blue darken-4 ml-2"
              v-text="n_nodes"
            ></v-chip>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-container fluid class="full-height">
      <v-row class="fill-height">
        <v-col class="text-center" cols="12" ref="netCol">
          <NetworkGraph v-if="showResultAction" :nodes="nodes" :edges="edges" :netOpt="netOpt" />
        </v-col>
      </v-row>
    </v-container>
    <!-- <GoTopBtn/> -->
  </v-container>
</template>

<script>
'use strict'

import NetworkTagInput from '../components/NetworkTagInput';
import GoTopBtn from '../components/GoTopBtn';
import NetworkGraph from '../components/NetworkGraph';
import { helper } from '../helper.js';
import { setUtils } from '../helper.js';
import { EventBus } from '../eventBus';

const N_CUTLINE = 5;

const PALETTE = {
  H: helper.gen_palette('G', N_CUTLINE),
  S: helper.gen_palette('B', N_CUTLINE),
};

const SIZE_DEGREE = helper.gen_nodesizedegree(N_CUTLINE, 20, 50);

function get_cutlines(arr, n) {
  let max = Math.max(...arr);
  let min = Math.min(...arr);
  let gap = max - min;
  let interval = gap / n;
  let rrr = [...Array(n).keys()];
  return rrr.map((i) => min + i * interval).slice(1);
}

function get_grade(val, cutlines) {
  let n_grade = cutlines.length;
  let tmp = cutlines.filter((e) => val < e);
  return n_grade - tmp.length;
}

function get_idx(e, dic) {
  return dic[e.g][e.n];
}

function get_edges(arr, net) {
  let score_sum = {};
  let edges = [];

  for (let i = 0; i < arr.length; i++) {
    let source = net[arr[i]];
    if (!source) {
      continue;
    }

    for (let j = i + 1; j < arr.length; j++) {
      let score = source[arr[j]];
      if (!score) {
        continue;
      }
      score_sum[i] = score_sum[i] ? score_sum[i] + score : score;
      score_sum[j] = score_sum[j] ? score_sum[j] + score : score;
      edges.push({
        tid: i,
        sid: j,
        name: score,
        _color: '#3399CC',
      });
    }
  }

  return [edges, score_sum];
}

function get_nodes(
  arr,
  score_sum,
  core_nodes,
  palette,
  sizedegree,
  idx2name,
  default_size = 20
) {
  let nodes = [];
  let cutlines = get_cutlines(Object.values(score_sum), N_CUTLINE);
  helper.log(palette);
  for (let i in arr) {
    let group = arr[i].slice(0, 1);
    let idx = parseInt(arr[i].slice(1));
    if (!score_sum[i]) {
      helper.log(idx2name[group][idx]);
    }
    let val = score_sum[i] ? score_sum[i].toFixed(2) : 0;
    let grade = get_grade(val, cutlines);
    let is_core = core_nodes.includes(arr[i]);
    nodes.push({
      id: i,
      name: idx2name[group][idx],
      // _color: (is_core)? "red" : palette[ group ][ grade ],
      _size: sizedegree[grade], // (score_sum[i])? score_sum[i].toFixed(2) : default_size,
      _cssClass: is_core
        ? 'core_node ' + group
        : 'neighbor ' + group + ' ' + 'G' + grade,
      // _labelClass: ( core_nodes.includes( arr[i] ) )? "core_node" : "neighbor_node"
    });
  }
  return nodes;
}

export default {
  name: 'CoNet',
  metaInfo: {
    title: 'Coword-Net',
    titleTemplate: '%s | Every Formula',
  },
  components: {
    NetworkTagInput,
    GoTopBtn,
    NetworkGraph,
  },

  data() {
    return {
      inputMsg: {
        label: 'Keywords (본초 병증)',
        suffix: '포함',
      },
      inputOpt: {
        multiple: true
      },
      dataDict: null,
      dataNet: null,
      allReady: false,
      setEventBus: [],
      showResultAction: false,
      dataItems: [],
      _nodes: [],
      nodes: [],
      edges: [],
      core_nodes: [],
      n_nodes: 0,
      netOpt: { force: 500, size: {h: "600", w: "600" } }
    };
  },

  created() {
    helper.log('Network Comp Created');

    if (EventBus.$data.dataReady) {
      // this.formulaList = EventBus.$data.formulaList;
      // this.formulaIdx = EventBus.$data.formulaIdx;
      // this.dataRidx = EventBus.$data.dataRidx;
      this.dataDict = EventBus.$data.dataDict;
      this.dataNet = EventBus.$data.dataNet;
      this.allReady = true;
    } else {
      EventBus.$on('appDataReady', (d) => {
        this.setEventBus.push('appDataReady');
        // this.formulaList = d.formulaList;
        // this.formulaIdx = d.formulaIdx;
        // this.dataRidx = d.dataRidx;
        this.dataDict = d.dataDict;
        this.dataNet = d.dataNet;
        this.allReady = true;
      });
    }
    // helper.log(this.dataNet);
  },
  destroyed() {
    if (this.setEventBus) {
      for (let e of this.setEventBus) {
        EventBus.$off(e);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  methods: {
    tagUpdated(val) {
      this.initShowResult();
      let _elems = [];
      let core_nodes = [];

      if (val.length == 0) {
        return;
      }

      for (let e of val) {
        let i = get_idx(e, this.dataDict.name2idx);
        let k = e.g + i.toString();
        core_nodes.push(k);
        if (this.dataNet.edges[k]) {
          let neighbor_nodes = Object.keys(this.dataNet.edges[k]);
          _elems.push(neighbor_nodes);
        }
      }

      let intersection = _elems.reduce(setUtils.intersectionCallback);

      // let rst_arr = [...new Set( elems )]
      intersection.sort();
      this.n_nodes = intersection.length;
      this.core_nodes = Object.freeze(core_nodes);
      this._nodes = Object.freeze(intersection.concat(this.core_nodes));
      helper.log(this.core_nodes);
      helper.log(this._nodes);
    },
    initShowResult() {
      delete this.edges;
      delete this.nodes;
      delete this._nodes;

      this.showResultAction = false;
      this.core_nodes = [];
      this._nodes = [];
      this.nodes = [];
      this.edges = [];
      this.n_nodes = 0;
    },
    showResult() {
      if (this.n_nodes == 0) {
        alert('검색결과가 없습니다.');
        return;
      }
      this.showResultAction = true;
      let score_sum;
      [this.edges, score_sum] = get_edges(this._nodes, this.dataNet.edges);
      helper.log(score_sum);
      this.nodes = get_nodes(
        this._nodes,
        score_sum,
        this.core_nodes,
        PALETTE,
        SIZE_DEGREE,
        this.dataDict.idx2name
      );
      this.onResize()
      helper.log(this.dataItems);
      helper.log(this.nodes);
      helper.log(this.edges);
    },
    onResize() {
      this.netOpt.size.w = this.$refs.netCol.clientWidth * 0.8
      this.netOpt.size.h = this.$refs.netCol.clientWidth * 0.8
    }
  }, // method
  watch: {
    allReady() {
      helper.log('allReady Green!!');
      let rst = this.dataDict
        ? this.dataDict.allitems.filter((e) => {
            return e.g == 'H' || e.g == 'S';
          })
        : [];
      helper.log(this.dataDict);
      helper.log(rst);

      this.dataItems = Object.freeze(rst);
    },
  },
  computed: {
    // dataItems() {
    //   if (this.allReady) {
    //     let rst = this.dataDict.allitems.filter((e) => {
    //       return e.g == 'H' || e.g == 'S';
    //     });
    //     // helper.log(rst);
    //     return Object.freeze(rst);
    //   } else {
    //     return Object.freeze([]);
    //   }
    // },
  }, // computed
};

// REF:
// https://cli.vuejs.org/guide/mode-and-env.html#example-staging-mode
</script>
